export enum FunctionalAreaSetting {
  monitoringPagesLimit = 'monitoringPagesLimit',
  pdfPagesLimit = 'pdfPagesLimit',
  academySeatsLimit = 'academySeatsLimit',
  digitalPropertyLimit = 'digitalPropertyLimit',
  monitoringPagesLimitWithFF = 'monitoringPagesLimitWithFF',
  userWayWebsiteLimit = 'userWayWebsiteLimit',
  dpComplexityEnabled = 'dpComplexityEnabled',
}

export enum $package {
  _id = '_id',
  name = 'name',
  settings = 'settings',
  roleIds = 'roleIds',
  roles = 'roles',
  legacy = 'legacy',
  createdAt = 'createdAt',
  updatedAt = 'updatedAt',
}

export enum $packageInstance {
  _id = '_id',
  tenantId = 'tenantId',
  packageId = 'packageId',
  packageDetails = 'packageDetails',
  originalPackage = 'originalPackage',
  packageAddonIds = 'packageAddonIds',
  packageAddons = 'packageAddons',
  createdAt = 'createdAt',
  updatedAt = 'updatedAt',
}

export enum $packageAddon {
  _id = '_id',
  name = 'name',
  description = 'description',
  roleIds = 'roleIds',
  availableIn = 'availableIn',
  featureFlag = 'featureFlag',
  createdAt = 'createdAt',
  updatedAt = 'updatedAt',
}

export enum PackageNames {
  Audit = 'Audit',
  LegacyEA = 'Legacy EA',
  Essentials_v2024 = 'Essentials+',
  Accelerate_v2024 = 'Accelerate+',
  Enterprise_v2024 = 'Enterprise+',
  Basic_v2025 = 'Basic',
  Essentials_v2025 = 'Essentials',
  Accelerate_v2025 = 'Accelerate',
  Enterprise_v2025 = 'Enterprise',
  Pro = 'Pro',
  ODT_Standalone = 'ODT Standalone',
}

export enum PackageAddonNames {
  Self_Manual_Testing = 'Test Accelerator (Self manual testing)',
  Live_App_Testing = 'Live app testing',
  Custom_Severities = 'Custom severities',
  Custom_Rule_Library = 'Custom rule library',
  Scanning_Agent = 'Outpost',
  UserWay_Integration = 'UserWay Integration',
  Scan_Rules_Curations = 'Scan Rules Curations',
  Issue_Tracking_Integrations = 'Issue tracking integrations',
  Scanning_And_Reporting_APIs = 'Scanning and reporting APIs',
  Common_Findings = 'Common Findings',
  Reporting_Program_View = 'Reporting - Program View',
  Reporting_Essentials = 'Reporting - Essentials',
  LevelDocs = 'LevelDocs',
}

export const basicPackagesForCFAddon: PackageNames[] = [PackageNames.Basic_v2025];

export const acceleratePackagesForCFAddon: PackageNames[] = [PackageNames.Accelerate_v2025, PackageNames.Accelerate_v2024];
